export default __webpack_public_path__ + "static/media/44t.f7e22e2f.jpg";